import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Message } from 'semantic-ui-react';

// Selectors
import {
    selectTimesheetEntriesApiErrorMessages
    // @ts-ignore
} from 'services/timesheetTimesheetEntriesAPIErrors/selectors';

export interface OwnProps {}

interface StateProps {
    messages: string[];
}

interface DispatchProps {}

type IProps = StateProps & DispatchProps & OwnProps;

export class TimesheetTimesheetEntriesApiErrorMessages extends React.PureComponent<
    IProps
> {
    render() {
        const { messages } = this.props;
        return (
            <React.Fragment>
                {messages.map(message => (
                    <Message error key={message}>
                        {message}
                    </Message>
                ))}
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    messages: selectTimesheetEntriesApiErrorMessages
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(
    TimesheetTimesheetEntriesApiErrorMessages
);
